import WorkOrderType from "./workOrderType";

const getDisplayValue = (workOrderType: WorkOrderType) => {
  let displayValue = "";

  switch (workOrderType) {
    case WorkOrderType.PreventativeMaintenance:
      displayValue = "Preventative Maintenance";
      break;

    default:
      displayValue = workOrderType;
      break;
  }

  return displayValue;
};

const workOrderTypeHelper = {
  getDisplayValue,
};

export default workOrderTypeHelper;
